import React from "react";
import { useTranslation } from "react-i18next";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import ContactLoginForm from "./ContactLoginForm";

interface ContactLoginDialogProps {
  open: boolean;
  email?: string;
  paymentLinkSlug?: string;
  onClose: () => void;
  onAuthenticated: () => void;
}

const ContactLoginDialog: React.FC<ContactLoginDialogProps> = ({
  open,
  email,
  paymentLinkSlug,
  onClose,
  onAuthenticated,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t("Verify your email")}</DialogTitle>

      <DialogContent>
        <ContactLoginForm
          // Remount on reopen to clear stale verification codes and errors.
          key={open ? "open" : "closed"}
          email={email}
          paymentLinkSlug={paymentLinkSlug}
          autoSend={!!email}
          onAuthenticated={onAuthenticated}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ContactLoginDialog;
